// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body[data-v-3bed9268] {\n  overflow: visible !important;\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n}\nbody[data-v-3bed9268]::-webkit-scrollbar {\n  display: none !important;\n}", ""]);
// Exports
module.exports = exports;
